import { useEffect, useState } from 'react';
import { IListingRequest } from '@vivli/features/listing-request/infrastructure/interface';
import { first } from 'rxjs/operators';
import { useListingRequestApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';
import { ListingRequestStatusEnum } from '@vivli/features/listing-request/infrastructure/enum';
import { useParams } from 'react-router';

const defaultListingRequest: IListingRequest = {
    datasetIds: [],
    requester: {
        email: '',
        institutionName: '',
        userId: ''
    },
    // DEV-890: hasBeenSigned is obsolete; kept because the model still declares it.
    hasBeenSigned: false,
    history: [],
    status: ListingRequestStatusEnum.Draft,
    datasets: [],
    submittedDate: null,
    approvedDate: null,
    withdrawnDate: null,
    createdDate: null,
    chatChannelId: null,
    isDataEmbargoed: false,
    canBeContacted: false,
    willNeedHelpAnonymizing: false
};

export const useListingRequest = () => {
    const { id } = useParams();

    const [listingRequest, setListingRequest] = useState<IListingRequest>(null);
    const [loadingRequest, setLoadingRequest] = useState(false);

    const listingRequestService = useListingRequestApiContext();
    const modalService = useModalApiContext();

    const handleLoadingError = (e) => {
        setLoadingRequest(false);
        modalService.error(e);
    };

    const getListingRequest = (id) => {
        setLoadingRequest(true);
        listingRequestService
            .getListingRequest(id)
            .pipe(first())
            .subscribe({
                next: (lr) => {
                    setListingRequest(lr);
                    setLoadingRequest(false);
                },
                error: handleLoadingError
            });
    };

    useEffect(() => {
        if (id && id !== 'draft') {
            getListingRequest(id);
            return;
        }

        if (!listingRequest) {
            setListingRequest(defaultListingRequest);
        }
    }, [id]);

    return { listingRequest, setListingRequest, loadingRequest };
};
